import { useEffect,useState } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiRequest } from "@/network/apiClient";

export const useOpportunityInventory = (page, pageSize, filters, searchName, fromAll) => {
    const [data, setData] = useState([]);
    const [totalOpportunity, setTotalOpportunity] = useState(0);
    const [absoluteTotal, setAbsoluteTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(0);
    const leadStatuses = [];
    const farmerToGet = []
    const statusNames = [];

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const queryParams = new URLSearchParams({
                    page: page.toString(),
                    page_size: pageSize.toString(),
                })
                // Add filters to the query parameters
                if (filters?.leadStatus?.length) {
                    leadStatuses.push(...filters.leadStatus)
                }
                leadStatuses.forEach(status => {
                    queryParams.append("lead_status", status);
                });
                if(filters?.farmer?.length) {
                    farmerToGet.push(...filters.farmer)
                }
                farmerToGet.forEach(farmer => {
                    queryParams.append('farmer_id',farmer)
                })
                // Handle name search
                if(searchName){
                    queryParams.append("name", searchName);
                }
                // Handle product selection
                if (filters?.products?.length) {
                    filters.products.forEach(product => {
                        queryParams.append("funnel", product);
                    });
                }
                // Handle status selection
                if (filters?.all_status?.length) {
                    statusNames.push(...filters.all_status)
                }
                if (filters?.remittance_status?.length) {
                    statusNames.push(...filters.remittance_status);
                }
                if (filters?.referral_status?.length) {
                    statusNames.push(...filters.referral_status);
                }
                if (filters?.insurance_status?.length) {
                    statusNames.push(...filters.insurance_status);
                }
                statusNames.forEach(status => {
                    queryParams.append("status_name", status);
                });
                if (fromAll === true){
                    queryParams.append('from_all','True')
                }else{
                    queryParams.append('from_all','False')
                }
                const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_OPPORTUNITIES.INVENTORY}?${queryParams.toString()}`)
                // Assign data to state
                if(result) {
                    setData(result.data);
                    setTotalOpportunity(result.total);
                    setAbsoluteTotal(result.absolute_total);
                    setTotalPages(result.total_pages);
                }else{
                    console.error("Failed to fetch lead inventory:", result.error);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
            }
        };        
        fetchData();
    }, [page, pageSize, filters, searchName]);

    return { data, totalOpportunity, isLoading, absoluteTotal, totalPages };
};
